export type Theme = 'default' | 'kenyaMoe'

type ThemeConfig = {
  name: Theme
  primaryMain: string
  logoSrc: string
}

const themeConfigs: Record<Theme, ThemeConfig> = {
  default: {
    name: 'default',
    primaryMain: '#5c3cd8',
    logoSrc: '/logo192.png',
  },
  kenyaMoe: {
    name: 'kenyaMoe',
    primaryMain: '#00aeee',
    logoSrc: '/kenya-moe-logo.png',
  },
}

const landscapingProjectOrgId = '89049ab4-0e99-4008-bebd-58e5634b2067'

export const getTheme = (organizationId: string | undefined): Theme =>
  organizationId === landscapingProjectOrgId ? 'kenyaMoe' : 'default'

export const getThemeConfig = (theme: Theme): ThemeConfig => themeConfigs[theme]
